import React from 'react'
import { insertScript, removeScript } from 'scripts/lib/utils'
import locale from 'shared/i18n/react'
import Constants from 'scripts/base/Constants'
import {connect} from 'scripts/store'
import UserCta from 'scripts/components/disqus/UserCta'

class Discussion extends React.Component {
  constructor(props) {
    super(props)
    this.state = { user: false }
    this.lang = locale.getLanguage() || Constants.DefaultLang
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.user) {
      this.setState({user: nextProps.user})
    }
  }

  componentWillMount() {
    if (typeof window !== 'undefined' && window.disqus_shortname && window.disqus_shortname !== this.props.shortname) {
      this.cleanInstance()
    }
  }

  componentDidMount() {
    this.loadInstance()
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.user && nextProps.user.disqus) {
      return true
    }
    if (this.props.shortname !== nextProps.shortname) {
      return true
    }
    const nextConfig = nextProps.config
    const config = this.props.config
    if (nextConfig.url === config.url || nextConfig.identifier === config.identifier) {
      return false
    }
    return true
  }

  componentWillUpdate(nextProps) {
    if (this.props.shortname !== nextProps.shortname) {
      this.cleanInstance()
    }
  }

  componentDidUpdate() {
    this.loadInstance()
  }

  loadInstance() {
    try {
      const doc = window.document
      if (window.DISQUS && doc.getElementById('dsq-embed-scr')) {
        const conf = {
          reload: true,
          config: this.getDisqusConfig(this.props.config)
        }
        window.DISQUS.reset(conf)
      } else {
        window.disqus_config = this.getDisqusConfig(this.props.config)
        window.disqus_shortname = this.props.shortname
        if (doc.getElementById('disqus_thread')) {
          insertScript(`https://${this.props.shortname}.disqus.com/embed.js`, 'dsq-embed-scr', doc.body)
        }
      }
    } catch (ex) {
      console.log('Error loading disqus', ex)
    }
  }

  cleanInstance() {
    try {
      const doc = window.document
      removeScript('dsq-embed-scr', doc.body)
      if (window && window.DISQUS) {
        window.DISQUS.reset({})
      }
      try {
        delete window.DISQUS
      } catch (error) {
        window.DISQUS = undefined
      }
      const disqusThread = doc.getElementById('disqus_thread')
      if (disqusThread) {
        while (disqusThread.hasChildNodes()) {
          disqusThread.removeChild(disqusThread.firstChild)
        }
      }
    } catch (ex) {
      console.log('error unloading disqus')
    }
  }

  getDisqusConfig = (config) => {
    const lang = this.lang
    const user = this.state.user
    return function () {
      this.page.identifier = config.identifier
      this.page.url = config.url
      this.page.title = config.title
      this.language = Constants.disqusLangs[lang]
      this.callbacks.onNewComment = [config.onNewComment]
      this.page.api_key = config.api_key
      this.page.remote_auth_s3 = (user ? user.disqus : null)
    }
  }

  render() {
    const userCtaElement = !this.state.user.disqus ? <UserCta /> : null
    return (
      <div className="container comment-container">
        <h2 className="section-title uppercase">{locale.general.comments}</h2>
        {userCtaElement}
        <div id="disqus_thread"></div>
      </div>
    )
  }
}

const mapToProps = ({user}) => {
  return {user}
}

export default connect(mapToProps)(Discussion)



// WEBPACK FOOTER //
// ./assets/js/components/disqus/Discussion.jsx